export function requestObjectMatchingLabels(object) {
  const labels = []
  if (object?.origin === 'REALTOR' || object?.origin === 'CLIENT') labels.push('Добавлен вручную')
  if (object?.matchesCurrentCriteria === false) labels.push('Не соответствует текущим критериям')
  return labels
}
